// extracted by mini-css-extract-plugin
export var content = "index-module--content--n72kt";
export var viewMoreJobButton = "index-module--viewMoreJobButton--XEzkt";
export var viewMoreJobs = "index-module--viewMoreJobs--DOW3O";